export default __webpack_public_path__ + "static/media/central_andes_1_4.184f7419.JPG";